import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Title from '../title';
import Branch from './branch';
import Executives from './executives';
import View from './view';

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
});

class Points extends React.Component {
  state = {
    values: 0
  };

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuControl = this.props.menus;
    menuControl.map((z) => {
      if (z.type == 'menucontrol') {
        if (z.menu == 'point-settings') {
          this.setState({ allow: '1' })
        }
      }
    })
  }


  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  onChange(val) {
    this.setState({
      values: val
    });
  }

  render() {
    const { classes, theme } = this.props;
    let x, y, z, section, category, brand;
    if (this.state.values == 0) {
      x = (<Executives />);
    }
    if (this.state.values == 1) {
      y = (<Branch />);
    }
    if (this.state.values == 2) {
      z = (<View />);
    }

    return (
      <div className={classes.root}>
        <Title title={'Point settings'} openDrawer={this.props.openDrawer} />
        { this.state.allow == '1' ?
          (
            <div>
              <AppBar position="static" color="default">
                <Tabs
                  value={this.state.values}
                  onChange={this.handleChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                >
                  <Tab label="Executives" onClick={this.onChange.bind(this, 0)} />
                  <Tab label="Branch" onClick={this.onChange.bind(this, 1)} />
                  <Tab label="View" onClick={this.onChange.bind(this, 2)} />
                </Tabs>
              </AppBar>
              <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={this.state.value}
                onChangeIndex={this.handleChangeIndex}
              >
                {x}{y}{z}
              </SwipeableViews>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

Points.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Points);
